// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-text a span{position:relative;z-index:2;color:white;padding:6px}.bastmain-wrap a span{position:relative;z-index:2;color:white;padding:6px}\n", ""]);
// Exports
module.exports = exports;
